<template>
  <div id="fdrtMainDiv">
    <div id="fdrtInputDiv">
      <el-input
        size="small"
        placeholder="输入关键字进行过滤"
        v-model="filterText">
      </el-input>
    </div>
    <div id="fdrtTreeDiv">
      <el-tree
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        class="filter-tree"
        :data="treeData"
        :props="defaultProps"
        node-key="id"
        highlight-current
        height="100%"
        :expand-on-click-node="false"
        @node-click="treeNodeClick"
        :filter-node-method="filterNode"
        :default-expanded-keys="defaultExpandedKeys"
        :default-checked-keys="defaultCheckedKeys"
        :show-checkbox="treeMsg.showCheckBox"
        :check-on-click-node="treeMsg.showCheckBox"
        :check-strictly="true"
        @check="getCheckedKeys"
        ref="tree">
      </el-tree>
    </div>
  </div>
</template>

<script>
  import {getRoleByUserId, getRoleTree} from "../api/baseRole";

  export default {
    data () {
      return {
        treeMsg: {
          title: '', // 标题
          refreshTreeFlag: false, // 刷新标志
          self: 1, // 是（1）否（0）包含自身
          async: 0, // 同步树（1）异步树（0）
          showCheckBox: true, // 是否显示多选框
          onlyLeaf: true // 是否只需要叶子节点(有多选框时使用)
        },
        filterText: '',
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        parentId: '-1',
        nodeId: '',
        formLabelWidth: '120px',
        chooseTreeNode: {},
        defaultExpandedKeys: [],
        defaultCheckedKeys: [],
        loading: false,
      }
    },
    props: {
      parentMsg: {
        isSingle: false,
        singleUserId: ''
      },
      filter:{
        type:Boolean
      }
    },
    watch: {
      filterText:{
        handler(newValue, oldValue) {
          this.$refs.tree.filter(newValue)
        },
      },
      parentMsg: {
        handler(newValue, oldValue) {
          this.defaultCheckedKeys = []
          this.treeMsg = newValue
          this.getTemplateTree(newValue)
        },
        immediate: true
      }
    },
    methods: {
      getTemplateTree (data) {
        let params = {
          parentId: '-1',
          self: this.treeMsg.self,
          async: this.treeMsg.async
        }
        this.treeData=[];
        // this.loading=true;
        getRoleTree(this.$qs.stringify(params)).then(response => {
          if (response.length <= 0) {
            this.$emit('treeInfo', { 'listenParentId': '-1', 'listenParentName': '暂无' })
            this.loading=false;
          } else {
            this.treeData = response
            // 展开至第一级
            this.defaultExpandedKeys = [response[0].id]
            if (response[0].children !== null && response[0].children.length > 0) {
              // 展开至第二级
              for (var i = 0; i < response[0].children.length; i++) {
                this.defaultExpandedKeys.push(response[0].children[i].id)
              }
            }
            // this.defaultExpandedKeys = [...new Set([...this.defaultExpandedKeys,...this.treeMsg.defaultCheckedKeys])];
            if (data.refreshTreeFlag !== 'refresh') {
              this.$emit('treeInfo', { 'listenParentId': response[0].id, 'listenParentName': response[0].label })
            }
            if (this.parentMsg.isSingle) {
              this.getRoleByUserId()
            }else{
              // this.loading=false;
            }
          }
        }).catch(error => {
          // this.loading=false;
          console.log('error:' + error.toString())
        })
      },
      getRoleByUserId() {
        this.loading=true;

        getRoleByUserId(this.$qs.stringify({userId: this.parentMsg.singleUserId}))
          .then(response => {
            console.log(response,9999);
            this.defaultExpandedKeys = []
            this.defaultCheckedKeys = []
            this.loading=false;
            if (response.success) {
              for (var index in response.data) {
                this.defaultExpandedKeys.push(response.data[index].roleId)
                this.defaultCheckedKeys.push(response.data[index].roleId)
              }
              // 过滤显示选中节点
              if (this.filter) {
                this.$nextTick(() => {
                  this.$refs.tree.filter(1)
                })
              }
            } else {
              console.log(response.msg)
            }
          }).catch(error => {
            this.loading=false;
            console.log('error:' + error.toString())
          })
      },
      treeNodeClick (node) {
        console.log(node);
        this.chooseTreeNode = node
        this.$emit('treeInfo', { 'listenParentId': node.id, 'listenParentName': node.label })
      },
      filterNode (value, data, node) {
        if (this.filter && !this.filterText) {
          return node.checked || node.indeterminate
        } else  {
          if (!value) return true;
          return data.label.indexOf(value) !== -1;
        }
      },
      getCheckedKeys (data){
        if (this.filter) {
          this.$refs.tree.filter(1)
        }
        this.$refs.tree.getCheckedKeys(true)
        this.$emit('getCheckedKeys', this.$refs.tree.getCheckedKeys(this.treeMsg.onlyLeaf),this.filter)
      }
    },
    mounted() {
      this.getTemplateTree()
    }
  }
</script>

<style lang="less">
  #fdrtMainDiv {
    max-height: 400px;
  }

  #fdrtInputDiv {
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  #fdrtTreeDiv {
    max-height: 358px;
    overflow: hidden;
    overflow-y: auto;
    .el-tree{
      height: 100%;
      overflow: hidden;
    }
  }

  /deep/.filter-tree{
    height: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/FDRolesTree.vue